import React from 'react';
import { Row, Col } from 'antd';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import { getChildrenToRender } from './utils';

class Content57 extends React.PureComponent {
  getChildren = (data) =>
    data.map((item) => {
      ['title', 'img', 'content'].forEach((key) => delete item[key]);
      return (
        <Col key={item.name} {...item}>
          {item.children.children.map(getChildrenToRender)}
        </Col>
      );
    });

  getBlockChildren = (data) =>
    data.map((item, i) => {
      const children = item.children;
      const ulChildren = this.getChildren(children.block.children);
      return (
        <Col key={i.toString()} {...item}>
          <div key="title" {...item.title}>
            {React.createElement('span', {
              dangerouslySetInnerHTML: { __html: item.title.children },
            })}
          </div>
          <Row key="ul" {...children.block}>
            {ulChildren}
          </Row>
        </Col>
      );
    });

  render() {
    const { ...props } = this.props;
    const { dataSource } = props;
    delete props.dataSource;
    delete props.isMobile;
    const listChildren = this.getBlockChildren(dataSource.block.children);
    return (
      <div {...props} {...dataSource.wrapper}>
        <div {...dataSource.page}>
          <div {...dataSource.bg}>
            <img src={dataSource.bg.children} width="100%" alt="img" />
          </div>
          <Row key="block" {...dataSource.block}>
            {listChildren}
          </Row>
        </div>
      </div>
    );
  }
}

export default Content57;
